/**
 * Format a name as "Prénom NOM" (first name capitalized, last name uppercase).
 * @param {string} firstName
 * @param {string} lastName
 * @returns {string}
 */
export function formatDisplayName(firstName, lastName) {
  const fn = (firstName || '').trim();
  const ln = (lastName || '').trim();
  const formattedFirst = fn ? fn.charAt(0).toUpperCase() + fn.slice(1).toLowerCase() : '';
  const formattedLast = ln ? ln.toUpperCase() : '';
  return `${formattedFirst} ${formattedLast}`.trim();
}

/**
 * Format a full name string (when only one "name" field is available).
 * Tries to split on space: first part = prénom, rest = NOM.
 * @param {string} fullName
 * @returns {string}
 */
export function formatFullName(fullName) {
  if (!fullName) return '';
  const parts = fullName.trim().split(/\s+/);
  if (parts.length === 1) return parts[0];
  const first = parts[0];
  const last = parts.slice(1).join(' ');
  return formatDisplayName(first, last);
}
